declare var angular: any;
declare var Fuse: any;
import * as _ from 'underscore';
import * as moment from 'moment';

angular.module('TeacherControllers')

  .controller('TeacherExamBrightCtrl', ['$scope', '$mdDialog', 'api', '$mdToast', 'EXAM', function($scope, $mdDialog, api, $mdToast, EXAM) {
    $scope.token = api.data.token;

    function getAssessments() {
      api.getAssessments().then(function(plans) {
        console.log(plans);
        $scope.realPlans = plans;

        if ($scope.currentPlan && $scope.currentPlan.id) {
          var findCurrentPlan = _.find(plans, function (plan: any) {
            return (plan.id === $scope.currentPlan.id);
          });
          if (findCurrentPlan) {
            $scope.showPlan(findCurrentPlan);
          }
        };

        plans = _.sortBy(plans, 'openedDate').reverse();

        plans = _.groupBy(plans, function(plan: any) {
          return !!plan.openedDate;
        });

        $scope.plans = plans;
      });
    }

    getAssessments();

    var fuse;
    api.getClass().then(function (data) {
      $scope.students = data.students;

      var options = {
        keys: ['user.email', 'user.first_name', 'user.last_name', 'user.username'],
        // id: 'profile.id'
      };

      fuse = new Fuse(data.students, options);
    });

    $scope.showPlan = function(plan) {
      $scope.currentPlan = plan;

      if (!plan.openedDate) {
        return;
      }

      $scope.currentExtendedPlan = {
        "load": true,
        "show": true
      };

      api.getBrightAssessmentsResult(plan.id).then(function(res) {
        console.log(res.data);
        $scope.currentExtendedPlan.data = res.data;
        $scope.currentExtendedPlan.load = false;
      });
    };


    $scope.closeShowPlan = function() {
      $scope.currentPlan = null;
      $scope.currentExtendedPlan = {
        "load": false,
        "show": false
      };
    };


    $scope.querySearch = function(query) {
      var results = fuse.search(query);
      return results;
    };


    $scope.newExamSession = function(ev, brightAssessment) {
      $mdDialog.show({
        templateUrl: '/ng1/www/modules/teacher/bright/html/new_exam_session.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        preserveScope: true,
        parent: angular.element(document.body),
        controller: ["$scope", "$mdDialog", function DialogController($scope, $mdDialog) {
          var initBrightAssessmentState = _.extend({
            title: null,
          }, brightAssessment);


          $scope.brightEdit = initBrightAssessmentState;

          $scope.hide = function() {
            $mdDialog.hide();
          };

          $scope.cancel = function() {
            $mdDialog.cancel();
          };

          $scope.submit = function() {
            api.insertBrightAssessments($scope.brightEdit).then(function (plan) {
              $mdToast.show(
                $mdToast.simple()
                  .textContent('La session de ' + EXAM + ' officiel a bien été créée')
                  .position('bottom right')
                  .hideDelay(3000)
              );
              $mdDialog.hide(plan);
            });
          };

        }]
      }).then(function(plan) {
        getAssessments();
        console.log(plan);
      });

    };

    $scope.addStudent = function (student) {
      api.addStudentToBrightAssessments($scope.currentPlan.id, student.profile.id).then(function () {
        $mdToast.show(
          $mdToast.simple()
            .textContent('L\'apprenant a bien été ajouté à la session')
            .position('bottom right')
            .hideDelay(3000)
        );
        getAssessments();
      });

    };

    $scope.deleteStudent = function (bright_assessment_id) {
      console.log('remove student', bright_assessment_id);
      api.removeStudentFromBrightAssessments(bright_assessment_id).then(function () {
        $mdToast.simple()
        .textContent('L\'apprenant a bien été retiré de la session')
        .position('bottom right')
        .hideDelay(3000)
        getAssessments();
      });
    };

    var htmlContent = "À partir du moment où vous donner l’accés au BRIGHT, les candidats ont 3 heures maximum pour le terminer. \
<br><br>\
    <b>Rappel du protocole de passation d’un BRIGHT certifiant :</b>\
<br>\
<ul><li>Le responsable d’une session de certification (dénommé ci après administrateur) doit vérifier l’identité du candidat.</li>\
<li>Le candidat doit laisser son téléphone portable ou tout autre outil qui pourrait l’aider dans son passage de test</li>\
<li>L’administrateur surveillera le/les candidats pendant la durée du test.</li>\
<li>L’administrateur veillera à ce que le/les candidats ne quittent pas l’application afin d’accéder à d’autres sites qui pourraient les aider à répondre aux questions.</li>\
<li>Le test doit rester confidentiel, nous ne pouvons tolérer aucunes captures d’écrans.</li></ul>\
    ";

    $scope.openTheExam = function(ev) {
      var confirm = $mdDialog.confirm({
        preserveScope: true,
        parent: angular.element(document.body),
      })
      .title('Êtes-vous sûr de vouloir donner accès imédiatement au BRIGHT certifiant ?')
      .htmlContent(htmlContent)
      .ariaLabel('Ouverture d\'examen')
      .ok('Confirmer')
      .cancel('Annuler')
      .targetEvent(ev);

      $mdDialog.show(confirm).then(function() {
        $scope.currentPlan.openedDate = moment.utc().toISOString();
        api.insertBrightAssessments($scope.currentPlan).then(function (plan) {
          getAssessments();
        });
      });


    };



    $scope.deleteExamSession = function(plan, ev) {
      var confirm = $mdDialog.confirm({
        preserveScope: true,
        parent: angular.element(document.body),
      })
        .title('Êtes-vous sur de vouloir supprimer cette session ?')
        .textContent("L'historique des résultats ne sera plus disponible")
        .ariaLabel('Suppression de la session')
        .ok('Confirmer')
        .cancel('Annuler')
        .targetEvent(ev);

      $mdDialog.show(confirm).then(function() {
        api.deleteBrightAssessmentsById(plan.id).then(function(data) {
          console.log('Success');

          getAssessments();

          $mdToast.show(
            $mdToast.simple()
              .textContent('Ce ' + EXAM + ' officiel a bien été supprimé')
              .position('bottom right')
              .hideDelay(3000)
          );
        }, function(data) {
          console.log(data);
          $mdToast.show(
            $mdToast.simple()
              .textContent('Une erreur est survenue')
              .position('bottom right')
              .hideDelay(2000)
          );
        });
      });
    };

  }
  ]);
